import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const backendDomain = "https://srijyothipolytechnic.com/api";

const EventsScreen = () => {
  const { state } = useLocation(); // Retrieve event details passed through the state
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null); // Track the index of the selected image

  // If no state is passed, show an error or redirect to the home page
  if (!state || !state.eventDetails || !state.allEvents) {
    return <div>Event details not available.</div>;
  }

  const event = state.eventDetails;
  const allEvents = state.allEvents;

  // Filter events that have the same category name as the one passed         
  const filteredEvents = allEvents.filter((e) => e.category_name === event.category_name);

  const openModal = (image, index) => {
    setSelectedImage(image); // Set the clicked image to display in modal
    setCurrentIndex(index); // Set the index of the selected image
  };

  const goToNextImage = () => {
    if (currentIndex === null) return;
    const nextIndex = (currentIndex + 1) % filteredEvents.length; // Cycle back to the first image
    setSelectedImage(filteredEvents[nextIndex].event_image ? `${backendDomain}/events/${filteredEvents[nextIndex].event_image}` : null);
    setCurrentIndex(nextIndex);
  };

  const goToPreviousImage = () => {
    if (currentIndex === null) return;
    const prevIndex = (currentIndex - 1 + filteredEvents.length) % filteredEvents.length; // Cycle back to the last image
    setSelectedImage(filteredEvents[prevIndex].event_image ? `${backendDomain}/events/${filteredEvents[prevIndex].event_image}` : null);
    setCurrentIndex(prevIndex);
  };

  return (
    <div className="p-8">
      <div className="flex items-center justify-center">
        <h1 className="text-3xl font-bold text-center mb-8 pb-2 inline-block border-b-2 border-[#565656]">
          {event.category_name}
        </h1>
      </div>

      {/* Display all events with the same category */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-[90%] mx-auto">
        {filteredEvents.map((event, index) => {
          // Construct the image URL using the backend domain and event_image
          const imageUrl = event.event_image ? `${backendDomain}/events/${event.event_image}` : null;

          // If imageUrl is missing or null, use a fallback image or hide the image
          return (
            <div
              key={event.event_id}
              className="border border-gray-200 shadow-lg overflow-hidden hover:scale-105 transform transition"
              onClick={() => imageUrl && openModal(imageUrl, index)} // Pass the index to openModal
            >
              {imageUrl ? (
                <img
                  src={imageUrl} // Dynamically load the image URL from the backend API
                  alt={event.event_name}
                  className="w-full h-48 object-cover"
                />
              ) : (
                <div className="mt-5 w-full h-48 bg-gray-300 flex justify-center items-center">No Image</div> // Fallback UI when no image
              )}
            </div>
          );
        })}
      </div>

      {/* Modal with selected image */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="relative">
            <img
              src={selectedImage}
              alt="Selected"
              className="max-w-[90vw] max-h-[90vh] object-contain"
            />
            <button
              className="absolute top-0 right-0 pl-3 pt-1 pb-1 pr-3 text-white bg-red-500 rounded-full"
              onClick={() => setSelectedImage(null)} // Close the modal
            >
              X
            </button>
          </div>
        </div>
      )}

      {/* Full-screen next/previous buttons */}
      {selectedImage && (
        <>
          <button
            className="fixed left-0 top-2/4 transform -translate-y-1/2 text-white text-3xl bg-black rounded-full p-3 z-50"
            onClick={goToPreviousImage} // Go to previous image
          >
            &lt;
          </button>
          <button
            className="fixed right-0 top-2/4 transform -translate-y-1/2 text-white text-3xl bg-black rounded-full p-3 z-50"
            onClick={goToNextImage} // Go to next image
          >
            &gt;
          </button>
        </>
      )}
    </div>
  );
};

export default EventsScreen;
